export default __webpack_public_path__ + "static/people-search-fa0d306b9a2c75a3dca670d9f0c69ea2.svg";